import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAwsCredentials {
    accessKeyId: string
    sessionToken: string
    secretAccessKey: string
    expirationTimestamp: string
}

export interface IUserRoleState {
    _roleToCredentialPromises: {
        [role: string]: Promise<IAwsCredentials>,
    }
}

export interface IRoleCredentialActionPayload {
    role: string
    promise: Promise<IAwsCredentials>
}

const initialState: IUserRoleState = {
    _roleToCredentialPromises: {},
}

export const userRoleSlice = createSlice({
    name: 'userRoleSlice',
    initialState,
    reducers: {
        setCredentialPromiseForRole: (state, action: PayloadAction<IRoleCredentialActionPayload>) => {
            state._roleToCredentialPromises[action.payload.role] = action.payload.promise
        },
        clearCredentialPromiseForRole: (state, action: PayloadAction<{role: string}>) => {
            delete state._roleToCredentialPromises[action.payload.role]
        },
    },
})

export const {
    setCredentialPromiseForRole,
    clearCredentialPromiseForRole,
} = userRoleSlice.actions

export default userRoleSlice.reducer
